var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 279c-4 0-8-4-8-8s4-7 8-7h59c4 0 7 3 7 7s-3 8-7 8H68zm101 0c-4 0-7-4-7-8s3-7 7-7h85c4 0 7 3 7 7s-3 8-7 8h-85zM24 170h358v-35H24v35zm358 15H24v120c0 7 3 14 8 18 5 5 12 8 19 8h305c7 0 13-3 18-8 5-4 8-11 8-18V185zM24 120h358v-18c0-8-3-14-8-19s-11-8-18-8H51c-7 0-14 3-19 8s-8 11-8 19v18zm27-60h305c11 0 21 5 29 12 7 8 12 18 12 30v203c0 11-5 21-12 29-8 7-18 12-29 12H51c-12 0-22-5-29-12-8-8-13-18-13-29V102c0-12 5-22 13-30 7-7 17-12 29-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.94b759dcb1f8eb09ef659d6d315715f3.svg";
export { ForwardRef as ReactComponent };